import React from "react";

export const SignupBottom = () => {
  return <p>© 2022 Toggl. All rights reserved.</p>;
};
